import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const CheckRegisterToken = async (query) => {
  return await axios.post(url + "validateTokenForRegister", query);
};
